export const MenuItems = [
    {
        title: "About Me",
        link: "/about-me",
        cName: "nav-links"
    },
    {
        title: "Portfolio",
        link: "/portfolio",
        cName: "nav-links"
    },
    {
        title: "Contact",
        link: "/contact",
        cName: "nav-links"
    },
    {
        title: "Resume",
        link: "/resume",
        cName: "nav-links"
    },
]